module.exports = __webpack_public_path__ + "img/45_12.50fb5f7e.png";